<template>
    <CTable
        v-if="data.page"
        :isLoading="isLoading"
        v-model:columns="data.columns"
        v-model:page="data.page"
        :options="data.tableOptions"
        :manages="data.manages"
        :manageExtras="data.manageExtras"
        :rowActions="data.rowActions"
        :clientSide="true"
        :canRefresh="false"
    ></CTable>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../../app.logic";
import { initData, isLoading } from "./user-role.logic";

export default defineComponent({
    components: {
        CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        visibleUser: { default: true },
        visibleRole: { default: true }
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        return { props, data, refs, isLoading };
    }
});
</script>
